import { createI18n } from "vue-i18n";
import { LANG_MAP_LANG_CODE, DEFAULT_LANG, LangEnum } from "@/constant/lang";
import { Persistent } from "@/utils/cache/persistent";
import { LOCAL_KEY_LANG_SETTING } from "@/constant/storageKey";

// function getLangFiles() {
//   const context = require.context(".", false, /\.js$/);
//   let msg = {};
//   context.keys().forEach((key) => {
//     // 从 key 中提取文件名（去掉前面的 ./ 和文件扩展名）
//     const fileName = key.replace(/^\.\/(.*)\.js$/, "$1");
//     if (fileName === "index") return; // 忽略 index.js 文件
//     msg[fileName] = context(key).default; // 获取文件默认导出
//   });
//   return msg;
// }

// const messages = getLangFiles();

// 单例
export const i18n = createI18n({
  legacy: false,
  locale: LangEnum.EN_US,
  messages: {},
  fallbackLocale: LangEnum.EN_US,
  fallbackWarn: false,
  missingWarn: false,
});

export function setupI18n(app) {
  app.use(i18n);
}

export function useI18nWithOut() {
  const { t, locale } = i18n.global;
  return {
    t,
    locale,
  };
}

export function getCurrentLocaleValue() {
  // 获取本地存储的语言配置
  const langStorage = Persistent.getLocal(LOCAL_KEY_LANG_SETTING);
  let localeValue;
  if (langStorage) {
    localeValue = LANG_MAP_LANG_CODE[langStorage] || DEFAULT_LANG;
  } else {
    // 如果没有存储，则使用跟随系统语言
    const sysNavLang = window.navigator.languages[0]?.slice(0, 2).toLowerCase();
    localeValue = LANG_MAP_LANG_CODE[sysNavLang] || DEFAULT_LANG;
  }

  return localeValue;
}

// 按需异步加载多语言
export async function loadLanguageAsync() {
  const localeValue = getCurrentLocaleValue();
  const { locale, setLocaleMessage } = i18n.global;

  // 获取默认语言供fallback
  await import(
    /* webpackChunkName: "lang-[request]" */ `@/lang/${DEFAULT_LANG}.js`
  ).then((messages) => {
    setLocaleMessage(DEFAULT_LANG, messages.default);
  });

  // 获取当前语言
  if (localeValue !== DEFAULT_LANG) {
    await import(
      /* webpackChunkName: "lang-[request]" */ `@/lang/${localeValue}.js`
    ).then((messages) => {
      setLocaleMessage(localeValue, messages.default);
      locale.value = localeValue;
    });
  } else {
    locale.value = DEFAULT_LANG;
  }
}
